import TaskListMain from './task-list-main'
const EmailTaskList: React.FC = () => <TaskListMain />
export default EmailTaskList
